import { render, staticRenderFns } from "./Ideas.vue?vue&type=template&id=8a60c20e&scoped=true"
import script from "./Ideas.vue?vue&type=script&lang=js"
export * from "./Ideas.vue?vue&type=script&lang=js"
import style0 from "./Ideas.vue?vue&type=style&index=0&id=8a60c20e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a60c20e",
  null
  
)

export default component.exports